import {useState, useEffect} from "react";
import ReadMore from "./ui/ReadMore";

export default function About() {
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        const checkHash = () => {
            if (window.location.hash === "#about") {
                setExpanded(true);
            }
        };
        // Run on page load
        checkHash();
        // Run when hash changes
        window.addEventListener("hashchange", checkHash);
        return () => window.removeEventListener("hashchange", checkHash);
    }, []);

    return <section id="about" className="m-5 p-5 bg-white rounded-xl shadow-lg scroll-mt-24">
        <h2 className="text-3xl font-bold mb-4 text-gray-800">About Us</h2>
        <div className="text-gray-700 leading-relaxed text-justify space-y-4">

            <p>
                <strong>R&Co. Chartered Professional Accountant</strong> is an accounting practice providing
                professional accounting, tax, and advisory services to individuals, self-employed professionals, and
                businesses.
            </p>
            <p>
                The practice is led by a <strong>Chartered Professional Accountant (CPA)</strong> and supported by a
                dedicated team,
                ensuring professional oversight, consistency, and accountability across all client engagements.
            </p>

            <ReadMore expand={expanded}>
                <p>Core services include financial reporting and compilation engagements, personal and corporate tax
                    preparation, tax planning, accounting and bookkeeping, payroll services, and business advisory
                    support. Each engagement is handled with a focus on accuracy, compliance, and practical
                    solutions tailored to the client’s circumstances.
                </p>

                <p>
                    In addition to core accounting services, complementary services such as <strong>insurance
                    solutions, investment guidance, and notary public services</strong> may be available where
                    appropriate and in
                    accordance with applicable regulations.
                </p>

                <p>
                    R&Co. Chartered Professional Accountant emphasizes long-term client relationships built on
                    trust, transparency, and professional integrity, providing reliable support in an evolving financial
                    and regulatory environment.
                </p>
            </ReadMore>
        </div>

    </section>;
}